import { observer }        from 'mobx-react-lite';
import { EyeOutlined }     from '@ant-design/icons';
import HeaderButton        from '@/TokamapEditor/ux/Header/HeaderButton';
import currentEditorStore  from '@/TokamapEditor/stores/currentEditorStore';
import { openPreview }     from '@/TokamapEditor/ux/Header/PreviewModal';
import onboardingStore     from '@/TokamapEditor/stores/onboardingStore';

const PreviewButton = observer(() => {
	if (!currentEditorStore.isCenterDefined) return null;

	return (
		<HeaderButton icon={<EyeOutlined />} className={onboardingStore.targetClass('preview')} onClick={() => {
			onboardingStore.notePreview();
			void openPreview();
		}}>
			Aperçu
		</HeaderButton>
	);
});

export default PreviewButton;
